import React from 'react';

type Props = {
    readonly onRemoveProductFromList: () => Promise<void>;
};

function RemoveFromProductlistButton({ onRemoveProductFromList }: Props) {
    return (
        <div className="default-dd-nav expanded-dd actions fl-left">
            <a className="bt-dd" onClick={onRemoveProductFromList}>
                <i className="material-icons up">delete</i>
            </a>
        </div>
    );
}

export default RemoveFromProductlistButton;
